import styled from 'styled-components';

interface IContainer {
  inLine: boolean;
  inLinePadding: boolean;
  isInvalid: boolean;
  size?: 'regular' | 'large';
}

interface ILabel {
  isInvalid: boolean;
}

export const Container = styled.div<IContainer>`
  position: relative;
  height: 100%;
  z-index: 0;

  .toggle-box {
    display: flex;
    height: 100%;
    gap: 6px;

    ${(props) =>
      props.inLine
        ? `
          ${props.inLinePadding ? 'padding-top: 30px;' : ''}
          flex-direction: row;
          justify-content: start;
          align-items: center;
          gap: 10px;
        `
        : `
          flex-direction: column;
          justify-content: space-evenly;
          align-items: start;
        `}
  }

  /* === customização toggle === */
  .custom-toggle.react-toggle {
    padding: 0;
    transition: all 0.2s ease;
    border-radius: 999px;

    /* Borda de foco */
    &:focus,
    &:focus-within {
      outline: 2px solid #4c9aff;
      outline-offset: 1px;
      box-shadow: 0 0 0 1px #4c9aff;
    }

    /* Remove outline padrão do navegador */
    &:focus {
      outline: none;
    }

    /* Aplica outline apenas quando focado via teclado */
    &:focus-visible {
      outline: 2px solid #4c9aff;
      outline-offset: 1px;
      box-shadow: 0 0 0 1px #4c9aff;
    }

    .react-toggle-track {
      background-color: #6b778c;
      border-radius: 999px;
      transition: all 0.2s;
      position: relative;
    }

    &.react-toggle--checked .react-toggle-track {
      background-color: ${(props) => props.color};
    }

    /* Borda mais sutil para o estado checked */
    &.react-toggle--checked:focus,
    &.react-toggle--checked:focus-within,
    &.react-toggle--checked:focus-visible {
      outline: 2px solid #4c9aff;
      outline-offset: 1px;
      box-shadow: 0 0 0 1px #4c9aff;
    }

    // bolinha do toggle
    .react-toggle-thumb {
      background-color: #fff;
      border-radius: 50%;
      transition: all 0.2s ease;
      box-shadow: 0 1px 3px;
      border-color: transparent;
    }
  }

  /* Ícones */
  .react-toggle-track-check {
    position: absolute;
    left: ${(props) => (props.size === 'large' ? '6px' : '4px')};
    top: ${(props) => (props.size === 'large' ? '40%' : '70%')};
    transform: translateY(-50%);
    color: #fff;
  }

  .react-toggle-track-x {
    position: absolute;
    right: ${(props) => (props.size === 'large' ? '6px' : '4px')};
    top: ${(props) => (props.size === 'large' ? '40%' : '70%')};
    transform: translateY(-50%);
    color: #fff;
  }

  &.react-toggle--disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:focus,
    &:focus-within,
    &:focus-visible {
      outline: none;
      box-shadow: none;
    }
  }

  .custom-toggle--regular.react-toggle {
    width: 32px;
    height: 16px;

    .react-toggle-track {
      width: 32px;
      height: 16px;
      // tamanho dos ícones
      svg {
        width: 10px;
        height: 8px;
      }
    }

    .react-toggle-thumb {
      width: 12px;
      height: 12px;
      top: 1.5px;
      left: 2px;
      border-color: transparent;
    }

    &.react-toggle--checked .react-toggle-thumb {
      left: 18px;
    }
  }

  .custom-toggle--large.react-toggle {
    width: 48px;
    height: 24px;

    .react-toggle-track {
      width: 48px;
      height: 24px;
    }

    .react-toggle-thumb {
      width: 20px;
      height: 20px;
      top: 1px;
      left: 2px;
    }

    &.react-toggle--checked .react-toggle-thumb {
      left: 26px;
    }
  }
`;

export const Label = styled.div<ILabel>`
  font-size: 0.8571428571428571em;
  font-style: inherit;
  line-height: 1.3333333333333333;
  color: ${(props) => (props.isInvalid ? '#cf1919' : '#6b778c')};
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;
